import http, { getCommParams } from './request'
import { getParams } from '@/utils/param-factory'

const CLUB_HOST = 'https://club.api.mgtv.com'

export async function getActivityParams(url) {
  return http({
    method: 'get',
    url,
    params: { ...getParams() },
  })
}

// 创建口令
export async function createWord(params) {
  return http({ method: 'get', url: CLUB_HOST + '/kl/word/create', params })
}
